module.exports = __webpack_public_path__ + "media/images/city_img/q_2-1c8ffc95db8b3502c0f6ac16f73c68ea.jpg";